import ReactDOM from 'react-dom';
import Content from './navigation/content';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navigation from './navigation/navigation';
import { Helmet } from './helper/helmet/helmet';

if (document.getElementById('jkit-admin-dashboard')) {
    const loadContent = () => {
        ReactDOM.render(
            <Router>
                <div className="jeg-elementor-kit-dashboard" >
                    <Helmet>
                        <link rel="preconnect" href="https://fonts.googleapis.com" />
                        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
                        <link href="https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap" rel="stylesheet" />
                    </Helmet>
                    <Navigation />
                    <Routes>
                        <Route path="*" element={<Content />} />
                    </Routes>
                </div>
            </Router>,
            document.getElementById('jkit-admin-dashboard')
        );
    }

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        loadContent();
    } else {
        window.addEventListener('load', () => {
            loadContent();
        })
    }
}
